export enum RecommendedAction {
  delete = 'MAIL_DELETE',
  quarantine = 'MAIL_QUARANTINE',
  moveToJunk = 'MAIL_MOVE_TO_JUNK_FOLDER',
  restore = 'MAIL_RESTORE',
  restoreFromQuarantine = 'MAIL_RESTORE_FROM_QUARANTINE',
  restoreFromJunk = 'MAIL_RESTORE_FROM_JUNK_FOLDER',
  restoreFromDeletedItems = 'MAIL_RESTORE_FROM_DELETED_ITEMS',
}

export enum MitigationType {
  AUTOMATIC,
  MANUAL,
}
